'use client';
import { jsx } from 'react/jsx-runtime';
import { DateFormat } from '../../../util/formatters/format-date.js';
import 'date-fns';
import 'date-fns/locale';
import '../../../util/datetime/constants.js';
import '../../../util/datetime/comparators.js';
import { formatTime } from '../../../util/formatters/format-time.js';
import '../../../types/order.js';
import '../../../types/category.js';
import { BaseEventBanner } from '../base-event-banner/base-event-banner.js';

const EventBanner = ({ eventUrl, title, coaches, duration, onClick, time, }) => {
    const eventDateTime = new Date(time);
    return (jsx(BaseEventBanner, { time: time, title: title, coaches: coaches, eventUrl: eventUrl, topLeft: "Free Event", description: `${formatTime(eventDateTime)} · ${duration} minutes`, onClick: onClick, dateFormat: DateFormat.LONG_DAY_OF_WEEK_MONTH_DAY }));
};

export { EventBanner };
//# sourceMappingURL=event-banner.js.map
